import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from './shared/services/auth.service';
import { CookieManagerService } from './shared/services/cookie-manager.service';
import { Constants } from './app.const';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  token: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private cookieService: CookieManagerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.setUrlParams();
    if (this.token) {
      this.getPreAuth(this.token);
    }
  }

  setUrlParams() {
    this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        this.token = param.t ? param.t : null;
      });
  }

  getPreAuth(token) {
    this.authService.signIn(token).subscribe(
      res => {
        this.cookieService.setCookie(Constants.cookieUserKey, token, false, 1);
        window.location.href = Constants.appUrl;
      },
      error => {
        window.location.href = Constants.loginUrl;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts